import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
import Pagination from '@/components/admin/pagination'
export default {
	components: {
		Pagination
	},
	data() {
		return {
			pageSize: 10,
			pageNum: 1,
			total: 0,
			status: '', //状态 0草稿 1已完成待发布  2已发布
			vacationId: '', //活动id
			vacationName: '',
			voteList: [],
			companyId: ''
		}
	},
	created() {
		this.companyId = localStorage.getItem('companyId')
		if(this.$route.query.id) {
			this.vacationId = this.$route.query.id
		}
		this.getVoteList()
	},
	methods: {
		//获取投票列表
		async getVoteList() {
			let param = {
				status: this.status,
				startCompanyId: this.companyId,
				vacationId: this.vacationId||'',
				pageNum: this.pageNum,
				pageSize: this.pageSize
			}
			ajaxParam(param)
			const res = await post('admin/voteInfo/list', qs.stringify(param))
			if (res.data.code == 200) {
				let datalist = res.data.page.items
				datalist.forEach(item => {
					item.showFlag = item.showFlag == '1' ? true : false
				})
				this.voteList = datalist
				this.total = res.data.page.count
				this.vacationName = res.data.vacationName
				this.vacationId = res.data.vacationId
			}

		},
		//分页
		handleCurrentChange(e){
			this.voteList = []
			this.pageNum = e
			this.getVoteList()
		},
		//发布投票
		publishVote(scope){
			this.$confirm('确定要发布吗？', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				let param = {
					id: scope.row.id
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/fb', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('发布成功！')
					this.getVoteList()
				}
			}).catch(() => {

			})
		},
		//修改投票
		modifyVote(row){
			this.$router.push({
				path: '/admin/addSelection?id='+row.id
			})
		},
		//详情
		detailVote(row) {
			this.$router.push({
				path: '/admin/vote/detail?id='+row.id
			})
		},
		//删除投票
		async deleteVote(scope) {
			this.$confirm('确定要删除选中的投票吗？', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				let param = {
					id: scope.row.id
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/delete', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('删除成功！')
					setTimeout(res=>{
						this.getVoteList()
					},300)
				}
			}).catch(() => {

			})
		},
		changeShowFlag(row){
			let status = row.showFlag?'停用':'启用'
			this.$confirm('确定要'+status+'吗？', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				let param = {
					id: row.id,
					showFlag: row.showFlag?'0':'1'
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/updateShowFlag', qs.stringify(param))
				if (res.data.code == 200) {
					this.voteList.forEach(item=>{
						if(item.id==row.id){
							item.showFlag = item.showFlag?false:true
						}
					})
					//this.getVoteList()
				}
			}).catch(() => {

			})
		},
		voteLog(row){
			this.$router.push({
				path: '/admin/voteList/voteLog?voteId='+row.id
			})
		},
	}
}
